<template>
  <div>
    <label :for="name" class="form-check form-switch form-switch-sm form-check-custom form-check-solid flex-stack mb-2">
      <span @click="labelAction_($event)" class="form-check-label ms-0 dm-fs-0-9-rem fw-bold fs-6" :class="{'text-gray-700': !labelAction, 'text-primary': labelAction}">{{ label }}</span>
      <input
          v-if="!labelOnly"
          type="checkbox"
          class="form-check-input"
          :class="{ 'is-invalid': form.errors.has(name) }"
          :id="name"
          :checked="value"
          @change="emitValue($event.target.checked)"
          :disabled="disabled"
      />
    </label>
    <div v-if="!labelOnly">
      <has-error :form="form" :field="name"></has-error>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String|Number,
      default: '',
      required: false,
    },
    name: {
      type: String|Number,
      required: true,
    },
    label: {
      type: String|Number,
      required: true,
    },
    labelAction: {
      default: false,
    },
    disabled: {
      default: false,
    },
    labelOnly: {
      default: false,
    },
    form: {
      type: Object,
      required: false,
    }
  },
  methods: {
    emitValue(value){
      this.$emit('input', value)
    },
    labelAction_(e){
      if(!this.labelAction) return;
      e.preventDefault()
      this.labelAction()
    },
  },
}
</script>